<div class="container p2p-details-list">
    <header>
        <div class="ml-n3 cursor--pointer" (click)="navigateByUrl('/manage/p2p/list')" style="color: #0076FF;">
            <i class="fas fa-chevron-left"></i>
            <span class="body-2 cursor--pointer"> Peer To Peer</span>
        </div>
        <div class="d-flex justify-content-between mt-3">  
            <div class="d-flex align-items-center mb-1">
                @if(campaignName === undefined) {
                    <h1 class="headline-4 mr-2 mb-0">{{campaingNameIfEmpty}}</h1>
                } @else {
                    <h1 class="headline-4 mr-2 mb-0">{{campaignName}}</h1>
                }
                <i (click)="onRefreshClick()" class="fas fa-sync blue-text cursor-pointer" style="font-size: 20px;"></i>
            </div>

            <ul class="d-flex flex-row justify-content-end actions-list list-group" style="height: 36px;" >
                @if (pledgePerEvent) {
                    <li (click)="onClickFulfillBulkPledges()" class="list-group-item d-flex px-2 mr-2">
                        <i class="fas fa-money-check-alt pointer"></i>
                        <span class="ml-2 pointer expanded-text body-1 ">Fulfill Bulk Pledges</span>
                    </li>

                    <li (click)="onClickAddBulkMilestones()" class="list-group-item d-flex px-2 mr-2">
                        <i class="fas fa-running pointer"></i>
                        <span class="ml-2 pointer expanded-text body-1 ">Add Bulk Milestones</span>
                    </li>
                }
                <li (click)="onClickCreate()"
                    class="list-group-item d-flex px-2 mr-2">
                    <i class="fas fa-plus pointer"></i>
                    <span class="ml-2 pointer expanded-text body-1 ">Create Fundraiser</span>
                </li>
                <li (click)="onClickImport()"
                    class="list-group-item d-flex px-2 mr-2">
                    <i class="fas fa-arrow-up pointer"></i>
                    <span class="ml-2 pointer expanded-text body-1 ">Import Fundraisers</span>
                </li>
                <li (click)="onClickDownloadQRCards()"
                    class="list-group-item d-flex px-2 mr-2">
                    <i class="fas fa-arrow-down pointer"></i>
                    <span class="ml-2 pointer expanded-text body-1 ">Download QR Fundraisers Cards </span>
                </li>
                <li (click)="onClickNotifyAll()"
                    class="list-group-item d-flex px-2 mr-2">
                    <i class="fas fa-bell pointer"></i>
                    <span class="ml-2 pointer expanded-text body-1 ">Notify All</span>
                </li>
            </ul> 
        </div>
        <span class="body-2 d-flex mb-3" style="color: #676767;">Created On {{creationUnix | date: 'MMM d, y'}}</span>
        <div class="d-flex">
            <div class="d-block">
                <img [src]="campaignImage" alt="Peer To Peer Campaign Image" class="img-fluid rounded-start" style="height: 110px; min-width: 220px; border-radius: 4px;">
            </div>
            <div class="d-flex w-100 ml-4">
                <div class="d-flex flex-column w-100">
                    <div class="row d-flex align-items-center mb-2">
                        <div class="col-3">
                            <span class="caption-p2p-leaderboard--text">Leaderboard</span>
                        </div>
                        <div class="col-9 d-flex align-items-center">
                            <a [href]="leaderboardUrl" class="caption-p2p-leaderboard--link" target="_blank" data-toggle="tooltip" data-placement="top" title="Tap to open in a new tab">
                                {{leaderboardUrl}}
                            </a>
                            <div (click)="copyIframeLink(leaderboardUrl)" class="d-flex justify-content-center align-items-center copy-link-icon cursor--pointer mx-2">
                                <i class="far fa-copy p-2"></i>
                            </div>
                            <button
                                type="button"
                                class="campaign__action btn btn--paybee btn--outline-transparent"
                                (click)="onClickDownload()"
                            >
                                <span>QR Code</span>
                                <i class="fas fa-download ml-1"></i>
                            </button>
                        </div>
                    </div>
                    <div class="row d-flex align-items-center mb-2">
                        <div class="col-3">
                            <span class="caption-p2p-leaderboard--text">Leaderboard iframe</span>
                            <i class="fas fa-question-circle fa-xs cursor--pointer pl-1" style="color: #D9D9D9;"></i>
                        </div>
                        <div class="col-9 d-flex align-items-center">
                            <a [href]="leaderboardIframeUrl" class="caption-p2p-leaderboard--link" target="_blank" data-toggle="tooltip" data-placement="top" title="Tap to open in a new tab">
                                {{leaderboardIframeUrl}}
                            </a>
                            <div (click)="copyIframeLink(leaderboardIframeUrl)" class="d-flex justify-content-center align-items-center copy-link-icon cursor--pointer ml-2">
                                <i class="far fa-copy p-2"></i>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-between mt-auto mr-1">
                        <div class="mb-2">
                            <span class="body-2 pl-1">
                                <span class="of-text">Raised</span> {{raised | currency:'USD':'symbol-narrow':'1.0-0'}} 
                                @if(goal !== 0) {
                                    <span class="of-text">of </span> 
                                    <span class="p2p-goal-text">{{goal | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
                                }
                            </span>
                        </div>
                        <div class="progress md-progress p2p-progress"
                            [innerHTML] = "progressBarHtml">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ul class="nav nav-tabs md-tabs md-tabs--paybee paybee-modal-header--regular-important p-0 mt-3" role="tablist">
            <li class="nav-item" style="margin-right: 0 !important;">
                <a [ngClass]="{'active': currentTab === 'champions'}" class="nav-link px-3 py-2" id="championsTabNav" data-fragment="championsTab" href="#championsTab" role="tab" aria-controls="championsTab"
                   aria-selected="true">Fundraisers</a>
            </li>
            @if(teamEnabled){
                <li class="nav-item" style="margin-right: 0 !important;">
                    <a [ngClass]="{'active': currentTab === 'teams'}" class="nav-link px-3 py-2" id="teamsTabNav" data-fragment="teamsTab" href="#teamsTab" role="tab" aria-controls="teamsTab"
                       aria-selected="true">Teams</a>
                </li>
            }
            <li  class="nav-item" style="margin-right: 0 !important;" >
                <a  [ngClass]="{'active': currentTab === 'reminders'}" class="nav-link px-3 py-2" id="remindersTabNav" data-fragment="remindersTab" href="#remindersTab" role="tab" aria-controls="remindersTab"
                   aria-selected="true">Reminders</a>
            </li>
            <li class="nav-item" style="margin-right: 0 !important;">
                <a [ngClass]="{'active': currentTab === 'fundraisersReport'}" class="nav-link px-3 py-2" id="fundraisersReportTabNav" data-fragment="fundraisersReportTab" href="#fundraisersReportTab" role="tab" aria-controls="fundraisersReportTab"
                   aria-selected="true">Fundraisers Report</a>
            </li>
            <li class="nav-item" style="margin-right: 0 !important;">
                <a [ngClass]="{'active': currentTab === 'donationsReport'}" class="nav-link px-3 py-2" id="donationsReportTabNav" data-fragment="donationsReportTab" href="#donationsReportTab" role="tab" aria-controls="donationsReportTab"
                   aria-selected="true">Donations Report</a>
            </li>
            <li class="nav-item" style="margin-right: 0 !important;">
                <a [ngClass]="{'active': currentTab === 'pledgesReport'}" class="nav-link px-3 py-2" id="pledgesReportTabNav" data-fragment="pledgesReportTab" href="#pledgesReportTab" role="tab" aria-controls="pledgesReportTab"
                   aria-selected="true">Pledges Report</a>
            </li>
        </ul>
    </header>

    @if(currentTab === 'champions') {
        @if(data.length > 0) {
            <div class="mb-5">
                <div class="d-flex justify-content-between align-items-center mb-1 mt-3">
                    <span class="headline-6">P2P Fundraisers ({{data.length}})</span>
                    <div class="card__right-side d-flex justify-content-end search">
                        <div class="search__icon-wrapper">
                            <i class="fas fa-search input-prefix"></i>
                        </div>
                        <input [formControl]="itemSearch" class="form-control--search" placeholder="Find Item" />
                        <div class="search__icon-wrapper--cross px-1">
                            @if(itemSearch.value.length > 0) {
                                <span class="cursor-pointer" (click)="resetSearch()">X</span>
                            }
                        </div>
                    </div>
                </div>
                @if(teamEnabled){
                    <div class="d-flex justify-content-between mt-3">
                        <app-p2p-items-filter-popover [p2pId]="p2pId"></app-p2p-items-filter-popover>
                        <button (click)="openP2pDetailModal()" type="button" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light shadow-none" aria-expanded="false" style="background-color: #fff;">
                            <i class="fas fa-search input-prefix mx-2"></i>
                            <span class="mr-2 form-control--search cursor-pointer">Donor Search...</span>
                        </button>
                    </div>
                }@else{
                    <div class="d-flex justify-content-end mt-3">
                        <button (click)="openP2pDetailModal()" type="button" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light shadow-none" aria-expanded="false" style="background-color: #fff;">
                            <i class="fas fa-search input-prefix mx-2"></i>
                            <span class="mr-2 form-control--search cursor-pointer">Donor Search...</span>
                        </button>
                    </div>
                }
            </div>
        }

        @for (data of peerToPeerManageService.filteredItems; track data.id) {
            <app-peer-to-peer-details-card [data]="data"></app-peer-to-peer-details-card>
        }

        @if(peerToPeerManageService.filteredItems.length < 1) {
            <div class="d-flex justify-content-center">No peer to peer fundraisers</div>
        }
    }

    @if(currentTab === 'teams') {
        <div class="tab-pane fade show pb-4" id="teamsTab" role="tabpanel" aria-labelledby="teamsTabNav">
            <div class="d-flex justify-content-between align-items-center mb-1 mt-3 mb-5">
                <span class="headline-6">Teams ({{teams.length}})</span>
                @if(data.length > 0) {
                    <button (click)="openP2pDetailModal()" type="button" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light shadow-none" aria-expanded="false" style="background-color: #fff;">
                        <i class="fas fa-search input-prefix mx-2"></i>
                        <span class="mr-2 form-control--search cursor-pointer">Donor Search...</span>
                    </button>
                }
            </div>
            
            @for (team of teams; track team.id) {
                <app-peer-to-peer-team-card [team]="team" [intid]="campaignDetail.intid"></app-peer-to-peer-team-card>
            }

            @if(teams.length < 1) {
                <div class="d-flex justify-content-center">No peer to peer teams</div>
            }
        </div>
    }

    @if(currentTab === 'reminders') {
        <div  class="tab-pane fade show pb-4" id="remindersTab" data-page="scheduleReminder" role="tabpanel" aria-labelledby="remindersTabNav">
            <div class="accordion md-accordion mt-3" style="border:none !important;" id="scheduleReminderAccordion" role="tablist" aria-multiselectable="true">

                <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="headline-6 px-3">Reminders</div>
                    <div class="d-flex align-items-center">
                        <div id="eventDateTime" class="body-1 mr-2"></div>
                        <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
                            <i class="fas fa-paper-plane mr-2"></i>
                            <span class="mr-2">Reminders</span>
                            <i class="fas fa-caret-down"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right">
                            <li [ngClass]="scheduleReminderClassList" data-id="scheduleCustomReminder_12" data-task-type="12" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                <a>Schedule Reminder...</a>
                            </li>
                            <li [ngClass]="scheduleReminderClassList" data-action="scheduleRecurringReminder" class="dropdown-item body-1">
                                <a>Schedule Weekly Reminder...</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="card" data-section="p2pWeeklyReminderCard" style="background-color: HSL(225, 40%, 98%);">
                    <div class="card-header d-flex align-items-center px-1" role="tab" id="p2pWeeklyReminderHeading" data-section="p2pWeeklyReminderHeading">
                        <a id="p2pWeeklyReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#p2pWeeklyReminderCollapse" aria-expanded="false" aria-controls="p2pWeeklyReminderCollapse">
                            <span class="headline-6 black-text pl-5 mb-2">Weekly</span>
                        </a>

                        <span data-action="cancelAllP2pWeeklyReminders" class="body-2--weight-medium cursor--pointer ml-3" style="color: #0076FF;">Cancel All</span>
                    </div>

                    <div id="p2pWeeklyReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="p2pWeeklyReminderHeading">
                        <div class="card-body pt-0 px-0">
                            <div class="col-12 col-xl-12" id="p2pWeeklyListContainer" data-section='p2pWeeklyReminderListContainer'></div>
                        </div>
                    </div>
                </div>

                <div class="card" data-section="scheduledReminderCard" style="background-color: HSL(225, 40%, 98%);">
                    <div class="card-header px-1" role="tab" id="scheduledReminderHeading" data-section="scheduledReminderHeading">
                        <a id="scheduledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#scheduledReminderCollapse" aria-expanded="false" aria-controls="scheduledReminderCollapse">
                            <span class="headline-6 black-text pl-5 mb-2">Scheduled</span>
                        </a>
                    </div>

                    <div id="scheduledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="scheduledReminderHeading">
                        <div class="card-body pt-0 px-0">
                            <div class="col-12 col-xl-12" id="scheduledListContainer" data-section='scheduledReminderListContainer'></div>
                        </div>
                    </div>
                </div>

                <div class="card" data-section="completedReminderCard" style="background-color: HSL(225, 40%, 98%);">
                    <div class="card-header px-1" role="tab" id="completedReminderHeading" data-section="completedReminderHeading">
                        <a id="completedReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#completedReminderCollapse" aria-expanded="false" aria-controls="completedReminderCollapse">
                            <span class="headline-6 black-text pl-5 mb-2">Completed</span>
                        </a>
                    </div>

                    <div id="completedReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="completedReminderHeading">
                        <div class="card-body pt-0 px-0">
                            <div class="col-12 col-xl-12" id="completedListContainer" data-section='completedReminderListContainer'></div>
                        </div>
                    </div>
                </div>

                <div class="card" data-section="cancelledReminderCard" style="background-color: HSL(225, 40%, 98%);">
                    <div class="card-header px-1" role="tab" id="cancelledReminderHeading" data-section="cancelledReminderHeading">
                        <a id="cancelledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#cancelledReminderCollapse" aria-expanded="false" aria-controls="cancelledReminderCollapse">
                            <span class="headline-6 black-text pl-5 mb-2">Cancelled</span>
                        </a>
                    </div>

                    <div id="cancelledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="cancelledReminderHeading">
                        <div class="card-body pt-0 px-0">
                            <div class="col-12 col-xl-12" id="cancelledListContainer" data-section='cancelledReminderListContainer'></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    }

    @if(currentTab === 'fundraisersReport'){
        <app-p2p-fundraisers-report-tab></app-p2p-fundraisers-report-tab>
    }

    @if(currentTab === 'donationsReport'){
        <app-p2p-donations-report-tab></app-p2p-donations-report-tab>
    }

    @if(currentTab === 'pledgesReport'){
        <app-p2p-pledges-report-tab></app-p2p-pledges-report-tab>
    }

</div>

